// Auto Discount Code Script
// Automatically applies a discount code to Shopify checkout
(function() {
  'use strict';

  // Discount code will be injected by Liquid template
  const discountCode = window.AUTO_DISCOUNT_CODE || '';
  const quantityLimit = window.AUTO_DISCOUNT_CODE_QUANTITY_LIMIT || 0;
  const DISCOUNT_APPLIED_KEY = 'discount_code_applied';
  let discountProcessed = false;
  let discountShouldApply = true; // Track whether discount should be applied based on quantity

  // Exit if no discount code is configured
  if (!discountCode) {
    return;
  }

  // Check if cart quantity exceeds the limit
  function cartExceedsQuantityLimit(cart) {
    if (!quantityLimit || quantityLimit <= 0) {
      return false; // No limit set, always apply
    }
    const totalQuantity = cart.item_count || 0;
    return totalQuantity > quantityLimit;
  }

  // Clear the discount attribute from cart
  function clearDiscountAttribute() {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        attributes: {
          [DISCOUNT_APPLIED_KEY]: ''
        }
      })
    })
    .then(response => response.json());
  }

  // Check if discount has already been applied to cart
  function checkAndApplyDiscount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        // Check if quantity exceeds limit
        if (cartExceedsQuantityLimit(cart)) {
          discountShouldApply = false;
          // Clear the discount attribute if it was previously set
          if (cart.attributes && cart.attributes[DISCOUNT_APPLIED_KEY]) {
            clearDiscountAttribute();
          }
          // Still setup interception, but it will check discountShouldApply before applying
          setupCheckoutInterception();
          return;
        }

        discountShouldApply = true;

        // Check if we've already marked this cart as processed
        const alreadyApplied = cart.attributes && cart.attributes[DISCOUNT_APPLIED_KEY] === discountCode;

        if (alreadyApplied) {
          discountProcessed = true;
          setupCheckoutInterception();
        } else {
          // Mark the cart as having the discount applied
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              attributes: {
                [DISCOUNT_APPLIED_KEY]: discountCode
              }
            })
          })
          .then(response => response.json())
          .then(() => {
            discountProcessed = true;
            setupCheckoutInterception();
          });
        }
      })
      .catch(error => {
        // Fallback: still setup interception even if API fails
        setupCheckoutInterception();
      });
  }

  // Function to intercept checkout and add discount parameter
  function setupCheckoutInterception() {
    // Intercept all checkout link clicks
    document.addEventListener('click', function(e) {
      const target = e.target.closest('a[href*="/checkout"], button[name="checkout"]');
      if (target) {
        // Re-check cart quantity before applying discount
        if (!discountShouldApply) {
          return; // Let default checkout proceed without discount code
        }

        if (target.tagName === 'A') {
          e.preventDefault();
          const url = new URL(target.href);
          url.searchParams.set('discount', discountCode);
          window.location.href = url.toString();
        }
      }
    }, true);

    // Intercept checkout form submissions
    document.addEventListener('submit', function(e) {
      if (e.target.action && e.target.action.includes('/checkout')) {
        // Re-check if discount should apply
        if (!discountShouldApply) {
          return;
        }

        let discountInput = e.target.querySelector('input[name="discount"]');
        if (!discountInput) {
          discountInput = document.createElement('input');
          discountInput.type = 'hidden';
          discountInput.name = 'discount';
          discountInput.value = discountCode;
          e.target.appendChild(discountInput);
        } else {
          discountInput.value = discountCode;
        }
      }
    }, true);

    // Store original fetch for AJAX checkout requests
    const originalFetch = window.fetch;
    window.fetch = function(...args) {
      let url = args[0];

      if (typeof url === 'string' && url.includes('/checkout')) {
        // Re-check if discount should apply
        if (!discountShouldApply) {
          return originalFetch.apply(this, args);
        }

        const urlObj = new URL(url, window.location.origin);
        urlObj.searchParams.set('discount', discountCode);
        args[0] = urlObj.toString();
      }

      return originalFetch.apply(this, args);
    };
  }

  // Re-check discount eligibility when cart updates
  // Listen for cart update events to re-evaluate quantity
  window.addEventListener('cart:updated', function() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const exceeds = cartExceedsQuantityLimit(cart);
        discountShouldApply = !exceeds;

        if (exceeds && cart.attributes && cart.attributes[DISCOUNT_APPLIED_KEY]) {
          clearDiscountAttribute();
        }
      });
  });

  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkAndApplyDiscount);
  } else {
    checkAndApplyDiscount();
  }
})();
